import { BoxProps } from '@mantine/core'

import { VerticalLayout } from './verticleLayout'
import { WideLayout } from './wideLayout'

export interface BaseInfoCardProps {
  title?: string
  description?: string
  thumbnail?: string
  ctaTitle?: string
  url?: string
}

export type InfoCardProps = BaseInfoCardProps & BoxProps

const _InfoCard = (props: InfoCardProps) => {
  return <VerticalLayout {...props} />
}

interface CompoundedComponent
  extends React.ForwardRefExoticComponent<InfoCardProps> {
  WideLayout: typeof WideLayout
  VerticalLayout: typeof VerticalLayout
}

const InfoCard = (_InfoCard as unknown) as CompoundedComponent

InfoCard.WideLayout = WideLayout
InfoCard.VerticalLayout = VerticalLayout

export default InfoCard
